<kendo-card width="100%">
  <kendo-card-body>
    <mat-drawer-container (backdropClick)="close()" autosize>
      <mat-drawer
        #drawer
        position="end"
        mode="over"
        (keydown.escape)="close()"
        disableClose
      >
        <content-details>
          @if (contentDetails) {
          <div>
            <ul>
              @if (
              contentDetails?.deployment_requirements.searchable_data?.length )
              {
              <li>
                <span>Searchable Data</span>
                <p>
                  {{
                  contentDetails.deployment_requirements.searchable_data.join(
                  ', ' ) }}
                </p>
              </li>
              } @if (
              contentDetails?.deployment_requirements.deployment_steps?.length )
              {
              <li>
                <span>Deployment Steps</span>
                <p>
                  <hyperkit-markdown
                    [md]="contentDetails.deployment_requirements.deployment_steps"
                  ></hyperkit-markdown>
                </p>
              </li>
              }
              <li>
                <span>Emulation & Validation</span>
                <pre>{{ deployItem.huntPackage.validation }}</pre>
              </li>
            </ul>
          </div>
          } @if (generatedContentDetails) {
          <div>
            @for (content of generatedContentDetails.content; track content) {
            <div>
              <strong
                >{{ generatedContentDetails.tool | uppercase }} - {{
                content.category | uppercase }}</strong
              >
              <pre>
                      {{ content.query }}
                      </pre
              >
            </div>
            }
          </div>
          } @if (latestHuntPackageChangeLog) {
          <div>
            <strong>Hunt Package ChangeLog:</strong>
            <ul>
              <li>
                <span>Date:</span>
                <p>{{latestHuntPackageChangeLog.date | date }}</p>
              </li>
              <li>
                <span>Note:</span>
                <p>{{latestHuntPackageChangeLog.note }}</p>
              </li>
            </ul>
            <strong>Content ChangeLog:</strong>
          </div>
          } @if (latestContentChangeLog) {
          <div class="content-changelog">
            <table
              mat-table
              [dataSource]="latestContentChangeLog"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.date | date }}
                </td>
              </ng-container>
              <ng-container matColumnDef="tool">
                <th mat-header-cell *matHeaderCellDef>Tool</th>
                <td mat-cell *matCellDef="let element">{{ element.tool }}</td>
              </ng-container>
              <ng-container matColumnDef="goal">
                <th mat-header-cell *matHeaderCellDef>Goal</th>
                <td mat-cell *matCellDef="let element">{{ element.goal }}</td>
              </ng-container>
              <ng-container matColumnDef="categories">
                <th mat-header-cell *matHeaderCellDef>Categories</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.categories }}
                </td>
              </ng-container>
              <ng-container matColumnDef="note">
                <th mat-header-cell *matHeaderCellDef>Note</th>
                <td mat-cell *matCellDef="let element">{{ element.note }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          }
        </content-details>
      </mat-drawer>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <package-header>
              <header-title>
                <hyperkit-link
                  routerLink="/research/hunt-package/{{ deployItem.huntPackageUUID }}"
                  variant="h5"
                  color="primary"
                  [text]="deployItem.huntPackage.title"
                >
                </hyperkit-link>
              </header-title>
              <header-options>
                @if (deployItem.huntPackage.severity) {
                <hyperkit-badge
                  indicator="dot"
                  [variant]="deployItem.huntPackage.severity | severityBadge"
                  size="large"
                  [text]="deployItem.huntPackage.severity"
                ></hyperkit-badge>
                } @if (outdated) {
                <div>
                  <div class="changelog">
                    <hyperkit-button
                      size="small"
                      color="secondary"
                      text="Changelog"
                      (click)="openChangeLog()"
                    ></hyperkit-button>
                  </div>
                  <hyperkit-button
                    size="small"
                    color="tertiary"
                    text="Re-Deploy"
                    (click)="markAsDeployed(deployItem.huntPackageUUID)"
                  ></hyperkit-button>
                </div>
                } @if (deployItem.deployedAt && !outdated) {
                <div>
                  <hyperkit-button
                    size="small"
                    color="secondary"
                    text=" Remove from Deployed"
                    (click)="removeDeployed(deployItem.huntPackageUUID)"
                  ></hyperkit-button>
                </div>
                } @if (!deployItem.deployedAt) {
                <hyperkit-button
                  size="small"
                  color="secondary"
                  text=" Unstage"
                  (click)="removeDeployed(deployItem.huntPackageUUID)"
                ></hyperkit-button>
                <hyperkit-button
                  size="small"
                  color="tertiary"
                  text=" Mark as Deployed"
                  (click)="markAsDeployed(deployItem.huntPackageUUID)"
                ></hyperkit-button>
                }
              </header-options>
            </package-header>
            <package-description>
              <hyperkit-typography
                variant="body"
                size="md"
                align="left"
                color="body"
              >
                {{ deployItem.huntPackage.description }}</hyperkit-typography
              >
              <ul>
                @if (deployItem.huntPackage.created_date != null) {
                <li>
                  <hyperkit-badge
                    variant="neutral"
                    text="Created"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{ deployItem.huntPackage.created_date | date: 'longDate'
                    }}</hyperkit-typography
                  >
                </li>
                } @if (deployItem.huntPackage.last_updated) {
                <li>
                  <hyperkit-badge
                    variant="neutral"
                    text="Updated"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{ deployItem.huntPackage.last_updated | date: 'longDate'
                    }}</hyperkit-typography
                  >
                </li>
                } @if (deployItem.deployedAt) {
                <li>
                  <hyperkit-badge
                    variant="neutral"
                    text="Deployed"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{ deployItem.deployedAt | date: 'longDate'
                    }}</hyperkit-typography
                  >
                </li>
                } @if (
                deployItem.huntPackage.mapping?.mitre?.mitre_attack_tactics.length
                != 0 ) {
                <li>
                  <hyperkit-badge
                    variant="neutral"
                    text="Tactics"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{
                    deployItem.huntPackage.mapping.mitre?.mitre_attack_tactics.join(
                    ', ' ) }}</hyperkit-typography
                  >
                </li>
                } @if (
                deployItem.huntPackage.mapping?.mitre?.mitre_attack_techniques.length
                != 0 ) {
                <li>
                  <hyperkit-badge
                    variant="neutral"
                    text="Techniques"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{
                    deployItem.huntPackage.mapping?.mitre?.mitre_attack_techniques.join(
                    ', ' ) }}</hyperkit-typography
                  >
                </li>
                }
              </ul>
              <div class="col-lg-12">
                <hyperkit-tab-bar variant="secondary" mode="underline">
                  @for (content of compatibleContent; track content) {
                  <hyperkit-tab
                    text="{{ content.tool }} - {{ content.goal}} - {{ content.deployment_requirements.categories.join(', ') }}"
                  >
                    <content-tab>
                      <hyperkit-button
                        size="small"
                        color="secondary"
                        text="View Details"
                        (click)="openContentDetails(content)"
                      ></hyperkit-button>
                      <hyperkit-button
                        size="small"
                        color="tertiary"
                        text="View Content"
                        (click)="openDeployContent(content)"
                      ></hyperkit-button>
                    </content-tab>
                  </hyperkit-tab>
                  }
                </hyperkit-tab-bar>
              </div>
            </package-description>
          </div>
        </div>
      </div>
    </mat-drawer-container>
  </kendo-card-body>
</kendo-card>
